import type { CopyShape } from "@tami/core/intl";

import type { INTERACTIVE_DEMO_COPY_PT_BR } from "../index.copy";

export const INTERACTIVE_DEMO_COPY_ES_ES: CopyShape<typeof INTERACTIVE_DEMO_COPY_PT_BR> = {
  exploreOnYourOwn: "Explorar la demo por tu cuenta",
};
